import { Suspense } from 'react';
import { Box } from '@wishket/design-system';
import { ErrorBoundary } from 'react-error-boundary';

import { getTrendingCollections } from './models';

import {
  TrendingCollections as TrendingCollectionsFeature,
  TrendingCollectionsHeader,
  TrendingCollectionsSkeleton,
} from '@/features/NewLanding';

const TrendingCollections = () => {
  const collectionsPromise = getTrendingCollections();

  return (
    <Box className="flex flex-col gap-6 desktop:gap-8">
      <TrendingCollectionsHeader />
      <ErrorBoundary fallback={<TrendingCollectionsSkeleton />}>
        <Suspense fallback={<TrendingCollectionsSkeleton />}>
          <TrendingCollectionsFeature collectionsPromise={collectionsPromise} />
        </Suspense>
      </ErrorBoundary>
    </Box>
  );
};

export default TrendingCollections;
